import { render, staticRenderFns } from "./Fileviewer.vue?vue&type=template&id=31346c56&"
import script from "./Fileviewer.vue?vue&type=script&lang=js&"
export * from "./Fileviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Fileviewer.vue"
export default component.exports